// store/slices/contactSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../services/api";

// Async thunk for submitting contact form
// store/slices/contactSlice.js
export const submitContactForm = createAsyncThunk(
  "contact/submitContactForm",
  async (contactData, { rejectWithValue }) => {
    try {
      // Make sure the payload matches exactly what API expects
      const response = await api.contact({
        name: contactData.name,
        email: contactData.email,
        mobile: contactData.mobile, // Make sure this is 'mobile' not 'phone'
        subject: contactData.subject,
        message: contactData.message,
      });
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to submit contact form",
      );
    }
  },
);

const initialState = {
  data: null,
  loading: false,
  error: null,
  success: false,
  message: null,
};

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    clearContactData: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.success = false;
      state.message = null;
    },
    resetContactState: (state) => {
      state.success = false;
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitContactForm.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
        state.message = null;
      })
      .addCase(submitContactForm.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.success = action.payload?.response || false;
        state.message =
          action.payload?.msg || "Your message has been submitted!";
        state.error = null;
      })
      .addCase(submitContactForm.rejected, (state, action) => {
        state.loading = false;
        state.success = false;

        // Handle validation errors (422)
        if (action.payload?.errors) {
          state.error = action.payload.errors;
          state.message = action.payload.message || "Validation error";
        }
        // Handle server errors (500)
        else if (action.payload?.message) {
          state.error = action.payload.message;
          state.message = action.payload.message;
        }
        // Handle other errors
        else {
          state.error = action.payload;
          state.message = action.payload || "Failed to submit contact form";
        }
      });
  },
});

export const { clearContactData, resetContactState } = contactSlice.actions;
export default contactSlice.reducer;
